/**
 * Returns the current array index.
 *
 * @example
 * values.map(toIndex);
 */
export default function toIndex(_value: unknown, index: number): number {
  return index;
}
